import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from "@angular/core";
import { DevicesService } from "../../devices/devices.service";
import { Constants } from "../../../shared/constants";
import { HistoricVar, QueryReadings } from "../../devices/device.model";
import { DatePipe } from "@angular/common";
import { GeneralService } from "../../../shared/services/general.service";
import { SessionStateService } from "../../../core/services/session-state.service";
import { Device } from "../../devices/devices.model_new";
import { HousesService } from "../../houses/houses.service";
import { GROUP } from "../../devices/devices.constant";
import { EnergyService } from "../energy.service";
@Component({
  selector: "app-energy-power",
  templateUrl: "./energy-power.component.html",
  styleUrls: ["./energy-power.component.scss"],
})
export class EnergyPowerComponent implements OnInit {
  @ViewChild("canvasPower") canvas: ElementRef;
  /**GRAPHIC */
  public selectedMoments;
  graphReadings: QueryReadings;
  selectedDate: string;
  currentSelectedDate = new Date(Date.now());
  public lineChartData: Array<any>;
  public lineChartLabels: Array<any>;
  public lineChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    scaleShowVerticalLines: false,
    elements: {
      line: { tension: 0, borderWidth: 2, borderColor: "#ea524b" },
      point: { radius: 0 },
    },
    scales: {
      xAxes: [
        {
          stacked: true,
          gridLines: {
            color: "#ECECEC",
            display: false,
          },
        },
      ],
      yAxes: [
        {
          stacked: true,
          gridLines: {
            color: "#ECECEC",
            display: true,
          },
          ticks: { min: 0 },
        },
      ],
    },
  };
  public lineChartLegend = false;
  public lineChartType = "line";
  public lineChartColors: Array<any>;
  activeView = "day";
  public max = new Date(Date.now());
  mode = "kW";
  sourceIds: Map<string, HistoricVar>;
  contractedPower: number;
  contractedPowerUnit: string;

  maxPowerMeasured: number;
  nextArrowPossible: boolean;
  integrationPeriodType = "0";
  selectionSeconds = "3600";
  loading = false;
  noData: boolean;
  totalValue: any;
  maxValue: any;
  gradient: any;
  /***/
  smartReaderDevice: Device;
  constructor(
    private devicesService: DevicesService,
    private energyService: EnergyService,
    private houseService: HousesService,
    private sessionStateService: SessionStateService
  ) {}
  ngOnInit() {
    this.houseService
      .getHouseContractedPower(this.sessionStateService.getHouse().houseId)
      .subscribe((value) => {
        this.contractedPower = value.contractedPower;
        this.contractedPowerUnit = value.unit;
      });

    this.devicesService
      .getSmartMeter(this.sessionStateService.getHouse().houseId)
      .subscribe((smartMeter: any) => {
        if (this.energyService.isMicroGeneration()) {
          this.smartReaderDevice = this.findConsumptionMeter(smartMeter);
        } else {
          this.smartReaderDevice = smartMeter[0];
        }
      });
  }

  changeMode(event) {
    this.mode = event;
  }

  maxPower(event) {
    this.maxPowerMeasured = event;
  }

  findConsumptionMeter(meters: Device[]) {
    let consumptionMeter: Device = meters[0];
    meters.forEach((meter) => {
      if (meter.getGroups().has(GROUP.CONSUMPTION_METER)) {
        consumptionMeter = meter;
      }
    });
    return consumptionMeter;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/energy/energy-power/energy-power.component.ts